<template>
  <div
    v-if="isAdminEnabled && isClientEnabled && uniId && (filterKey || filterValue)"
    :key="uniqueSlug"
  >
    <script
      async
      defer
      src="https://cdn.unibuddy.co/unibuddy-popcard.js"
      type="application/javascript"
    ></script>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Unibuddy',

  computed: {
    ...mapGetters([ 'myStore', 'unibuddyFilterObj' ]),
    isAdminEnabled() { return this.myStore(['settings', 'unibuddy_enabled']) ?? false },
    unibuddyOptions() { return this.myStore(['options', 'unibuddy']) ?? {} },
    isClientEnabled() { return this.unibuddyOptions.enabled ?? false },
    uniId() { return this.unibuddyOptions.uni_id ?? false },
    filterKey() { return this.unibuddyFilterObj.filterKey || undefined },
    filterValue() { return this.unibuddyFilterObj.filterValue || undefined },
    uniqueSlug() { return `unibuddy-uni-${this.uniId || 'none'}-key-${this.filterKey || 'none'}-value-${this.filterValue || 'none'}` }
  },

  watch: {
    uniqueSlug() { this.updateWindowData() }
  },

  beforeMount() {
    if (!window.unibuddySettings) { this.addWindowData() }
    this.updateWindowData()
  },

  methods: {
    removeIframe() {
      const $iframe = document.getElementById('unibuddy-popcard-iframe')
      if ($iframe) { $iframe.parentNode.removeChild($iframe) }
    },
    addWindowData() {
      window.unibuddySettings = {
        colour: '000',
        domain: 'https://popcard.unibuddy.co/',
        title: 'Unibuddy Popcard',
        align: 'right'
      }
    },
    updateWindowData() {
      this.removeIframe()
      window.unibuddySettings.uni_id = this.uniId
      window.unibuddySettings.filterKey = this.filterKey
      window.unibuddySettings.filterValue = this.filterValue
    }
  }
}
</script>

